const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlashcardAppPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 690 410",
    role: "img",
    style: {},
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, "Flashcard app placeholder image") : title ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("desc", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "A dark-themed illustration for a flashcard learning app with spaced repetition"), /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 400,
    fill: "#0f172a",
    rx: 16,
    style: {
      fill: "rgb(15, 23, 42)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 40,
    width: 320,
    height: 200,
    fill: "#1e293b",
    rx: 14,
    stroke: "#334155",
    strokeWidth: 1,
    style: {
      fill: "rgb(30, 41, 59)",
      stroke: "rgb(51, 65, 85)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 56,
    width: 288,
    height: 168,
    fill: "#0f172a",
    rx: 10,
    stroke: "#6366f1",
    strokeWidth: 1.5,
    style: {
      fill: "rgb(15, 23, 42)",
      stroke: "rgb(99, 102, 241)",
      color: "rgb(0, 0, 0)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 130,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#94a3b8",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(148, 163, 184)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 13,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "What is"), /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 152,
    textAnchor: "middle",
    fontSize: 18,
    fill: "#e2e8f0",
    fontFamily: "sans-serif",
    fontWeight: 600,
    style: {
      fill: "rgb(226, 232, 240)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 18,
      fontWeight: 600,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Spaced Repetition?"), /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 178,
    width: 100,
    height: 28,
    fill: "#6366f1",
    rx: 14,
    style: {
      fill: "rgb(99, 102, 241)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 197,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#ffffff",
    fontFamily: "sans-serif",
    fontWeight: 600,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 11,
      fontWeight: 600,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Reveal answer"), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 270,
    width: 140,
    height: 90,
    fill: "#1e293b",
    rx: 10,
    stroke: "#334155",
    strokeWidth: 1,
    style: {
      fill: "rgb(30, 41, 59)",
      stroke: "rgb(51, 65, 85)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 286,
    width: 60,
    height: 8,
    fill: "#334155",
    rx: 4,
    style: {
      fill: "rgb(51, 65, 85)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 302,
    width: 108,
    height: 6,
    fill: "#1e3a5f",
    rx: 3,
    style: {
      fill: "rgb(30, 58, 95)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 316,
    width: 80,
    height: 6,
    fill: "#1e3a5f",
    rx: 3,
    style: {
      fill: "rgb(30, 58, 95)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 334,
    width: 44,
    height: 18,
    fill: "#22c55e22",
    rx: 9,
    stroke: "#22c55e",
    strokeWidth: 1,
    style: {
      fill: "rgba(34, 197, 94, 0.133)",
      stroke: "rgb(34, 197, 94)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 347,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#22c55e",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(34, 197, 94)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Easy"), /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 270,
    width: 140,
    height: 90,
    fill: "#1e293b",
    rx: 10,
    stroke: "#334155",
    strokeWidth: 1,
    style: {
      fill: "rgb(30, 41, 59)",
      stroke: "rgb(51, 65, 85)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516,
    y: 286,
    width: 70,
    height: 8,
    fill: "#334155",
    rx: 4,
    style: {
      fill: "rgb(51, 65, 85)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516,
    y: 302,
    width: 108,
    height: 6,
    fill: "#1e3a5f",
    rx: 3,
    style: {
      fill: "rgb(30, 58, 95)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516,
    y: 316,
    width: 60,
    height: 6,
    fill: "#1e3a5f",
    rx: 3,
    style: {
      fill: "rgb(30, 58, 95)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 516,
    y: 334,
    width: 50,
    height: 18,
    fill: "#ef444422",
    rx: 9,
    stroke: "#ef4444",
    strokeWidth: 1,
    style: {
      fill: "rgba(239, 68, 68, 0.133)",
      stroke: "rgb(239, 68, 68)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 541,
    y: 347,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#ef4444",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(239, 68, 68)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "Hard"), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 370,
    width: 600,
    height: 16,
    fill: "#1e293b",
    rx: 8,
    style: {
      fill: "rgb(30, 41, 59)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 370,
    width: 240,
    height: 16,
    fill: "#6366f1",
    rx: 8,
    style: {
      fill: "rgb(99, 102, 241)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 382,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#94a3b8",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(148, 163, 184)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "12 / 30 cards"), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 60,
    r: 24,
    fill: "#1e293b",
    stroke: "#334155",
    strokeWidth: 1,
    style: {
      fill: "rgb(30, 41, 59)",
      stroke: "rgb(51, 65, 85)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 55,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#94a3b8",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(148, 163, 184)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "streak"), /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 72,
    textAnchor: "middle",
    fontSize: 14,
    fill: "#f59e0b",
    fontFamily: "sans-serif",
    fontWeight: 700,
    style: {
      fill: "rgb(245, 158, 11)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 14,
      fontWeight: 700,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "\uD83D\uDD257"), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 60,
    r: 24,
    fill: "#1e293b",
    stroke: "#334155",
    strokeWidth: 1,
    style: {
      fill: "rgb(30, 41, 59)",
      stroke: "rgb(51, 65, 85)",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 55,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#94a3b8",
    fontFamily: "sans-serif",
    style: {
      fill: "rgb(148, 163, 184)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 10,
      fontWeight: 400,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "due"), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 72,
    textAnchor: "middle",
    fontSize: 14,
    fill: "#6366f1",
    fontFamily: "sans-serif",
    fontWeight: 700,
    style: {
      fill: "rgb(99, 102, 241)",
      stroke: "none",
      color: "rgb(0, 0, 0)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "sans-serif",
      fontSize: 14,
      fontWeight: 700,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "18"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashcardAppPlaceholder);
export default __webpack_public_path__ + "static/media/flashcard_app_placeholder.bc1a8153c430db77fb397fee102dfaa1.svg";
export { ForwardRef as ReactComponent };